
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/certification/[...aggregator]",
      function () {
        return require("private-next-pages/browse/certification/[...aggregator].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/certification/[...aggregator]"])
      });
    }
  